import React from 'react';
import { Box, Typography, Divider, IconButton } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PlaceIcon from '@mui/icons-material/Place';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const Support = () => {
  const handleCallClick = () => {
    if (window.innerWidth <= 768) {
      window.location.href = 'tel:9237301652';
    } else {
      alert('Please use your phone to make the call.');
    }
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/0000000000', '_blank');
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:customercare@centeralkia.in';
  };

  return (
    <Box sx={{ padding: '20px', mt: '20px' }}>
      {/* Title */}
      <Typography
        variant="h4"
        sx={{
          mb: 1,
          color: '#3A3A3A',
          fontFamily: 'KIAbodyLatinbasic_Regular',
          fontWeight: 800,
          mt: '20px',
          ml: '40px',
        }}
      >
        Support
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mb: 4,
          color: '#666',
          ml: '40px',
          fontFamily: 'KIAbodyLatinbasic_Regular',
        }}
      >
        Get your queries answered using any of our official communication channels.
      </Typography>

      {/* Support Sections */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '40px', width: '90%' }}>
        {/* Call & WhatsApp */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', ml: '40px' }}>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ display: 'block', height: '90px', margin: '20px', width: '10px', backgroundColor: '#CCCCCC' }}
          />
          <a href="tel:+919237386213" style={{ textDecoration: 'none', color: 'inherit' }}>
            <PhoneIcon
              sx={{
                fontSize: 80,
                backgroundColor: '#f5f5f5',
                borderRadius: '50%',
                padding: 1,
                cursor: 'pointer',
                mb: 1,
                '&:hover': { backgroundColor: '#3A3A3A', color: 'white' },
              }}
            />
          </a>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Typography
              variant="body1"
              onClick={handleCallClick}
              sx={{ fontFamily: 'KIAbodyLatinbasic_Regular', cursor: 'pointer', mb: 0.5 }}
            >
              <b style={{ color: '#3A3A3A' }}>Call Us:</b> 9237301652
            </Typography>
            <Typography
              variant="body1"
              onClick={handleWhatsAppClick}
              sx={{ fontFamily: 'KIAbodyLatinbasic_Regular', cursor: 'pointer' }}
            >
              <b style={{ color: '#3A3A3A' }}>WhatsApp:</b> 9237301652
            </Typography>
          </div>
        </div>

        {/* Email Section */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', ml: '40px' }}>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ display: 'block', height: '90px', margin: '20px', width: '10px', backgroundColor: '#CCCCCC' }}
          />
          <a href="mailto:digitalsales@centralkia.in" target="_blank" style={{ textDecoration: 'none', color: 'inherit' }}>
            <EmailIcon
              sx={{
                fontSize: 80,
                backgroundColor: '#f5f5f5',
                borderRadius: '50%',
                padding: 1,
                cursor: 'pointer',
                mb: 1,
                '&:hover': { backgroundColor: '#3A3A3A', color: 'white' },
              }}
            />
          </a>
          <Typography
            variant="body1"
            onClick={handleEmailClick}
            sx={{ fontFamily: 'KIAbodyLatinbasic_Regular', cursor: 'pointer' }}
          >
            digitalsales@centralkia.in
          </Typography>
        </div>

        {/* Address Section */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', ml: '40px' }}>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ display: 'block', height: '90px', margin: '20px', width: '10px', backgroundColor: '#CCCCCC' }}
          />
          <PlaceIcon
            sx={{
              fontSize: 80,
              backgroundColor: '#f5f5f5',
              borderRadius: '50%',
              padding: 1,
              cursor: 'pointer',
              mb: 1,
              '&:hover': { backgroundColor: '#3A3A3A', color: 'white' },
            }}
            onClick={() =>
              window.open(
                'https://www.google.com/maps/dir/?api=1&destination=Kia+Showroom+Bhubaneswar',
                '_blank'
              )
            }
          />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Typography variant="body1" sx={{ cursor: 'pointer', fontFamily: 'KIAbodyLatinbasic_Regular' }}>
              <b style={{ color: '#3A3A3A' }}>Head Office Address:</b> PLOT NO-655 - 656, NH-16, NAKHARA, BALIANTA, BHUBANESWAR, Khordha, Odisha, 752101
            </Typography>
            <Typography variant="body1" sx={{ fontFamily: 'KIAbodyLatinbasic_Regular' }}>
              <b style={{ color: '#3A3A3A' }}>Showroom Address:</b> Plot No. 644/2148, NH-16, Pahal, Bhubaneswar, Odisha 752101
            </Typography>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <IconButton
        onClick={handleWhatsAppClick}
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          backgroundColor: '#25D366',
          color: '#fff',
          width: 56,
          height: 56,
          boxShadow: 3,
          '&:hover': { backgroundColor: '#1DA955' },
        }}
      >
        <WhatsAppIcon sx={{ fontSize: 30 }} />
      </IconButton>
    </Box>
  );
};

export default Support;
